import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import axios from 'axios'
import AuthShell from '../../components/common/AuthShell'

export default function ResetPassword() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [token, setToken] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [passwordError, setPasswordError] = useState('')

  useEffect(() => {
    const tokenParam = searchParams.get('token')
    if (!tokenParam) {
      setError('Kein gültiger Reset-Token gefunden')
    } else {
      setToken(tokenParam)
    }
  }, [searchParams])

  const validatePassword = (pwd) => {
    if (pwd.length < 8) {
      return 'Passwort muss mindestens 8 Zeichen lang sein'
    }
    if (!/[A-Z]/.test(pwd)) {
      return 'Passwort muss mindestens einen Großbuchstaben enthalten'
    }
    if (!/[a-z]/.test(pwd)) {
      return 'Passwort muss mindestens einen Kleinbuchstaben enthalten'
    }
    if (!/\d/.test(pwd)) {
      return 'Passwort muss mindestens eine Ziffer enthalten'
    }
    return ''
  }

  const handlePasswordChange = (e) => {
    const pwd = e.target.value
    setPassword(pwd)
    setPasswordError(validatePassword(pwd))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    // Passwort prüfen
    const pwdError = validatePassword(password)
    if (pwdError) {
      setPasswordError(pwdError)
      return
    }

    // Übereinstimmung prüfen
    if (password !== confirmPassword) {
      setError('Passwörter stimmen nicht überein')
      return
    }

    setLoading(true)

    try {
      await axios.post('http://localhost:8000/api/v1/auth/reset-password', {
        token,
        new_password: password
      })
      setSuccess(true)

      // Nach 3 Sekunden zum Login weiterleiten
      setTimeout(() => {
        navigate('/login')
      }, 3000)
    } catch (err) {
      if (err.response?.status === 400) {
        setError('Ungültiger oder abgelaufener Reset-Token. Bitte fordern Sie einen neuen an.')
      } else if (err.response?.data?.detail) {
        // Validierungsfehler aus Pydantic auslesen
        const detail = err.response.data.detail
        if (Array.isArray(detail)) {
          setError(detail.map(e => e.msg).join(', '))
        } else {
          setError(detail)
        }
      } else {
        setError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.')
      }
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <AuthShell
        title="Passwort erfolgreich zurückgesetzt!"
        subtitle="Ihr Passwort wurde erfolgreich geändert."
      >
        <p className="wc-muted" style={{ fontSize: 13, margin: 0 }}>
          Sie werden automatisch zum Login weitergeleitet…
        </p>
        <Link to="/login" className="wc-btn wc-btn-primary wc-btn-block">
          Zum Login
        </Link>
      </AuthShell>
    )
  }

  return (
    <AuthShell
      title="Neues Passwort festlegen"
      subtitle="Bitte geben Sie Ihr neues Passwort ein."
    >
      {!token ? (
        <div className="wc-alert wc-alert-error" role="alert">
          {error}
          <div style={{ marginTop: 8 }}>
            <Link to="/forgot-password">Neuen Reset-Link anfordern</Link>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 16 }}>
          {error && (
            <div className="wc-alert wc-alert-error" role="alert">
              {error}
            </div>
          )}

          <div className="wc-field">
            <label htmlFor="password">Neues Passwort</label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              required
              value={password}
              onChange={handlePasswordChange}
              className="wc-input"
              aria-invalid={passwordError ? 'true' : undefined}
            />
            {passwordError && (
              <p style={{ color: '#fca5a5', fontSize: 12, margin: '4px 0 0' }}>
                {passwordError}
              </p>
            )}
            <p className="wc-muted" style={{ fontSize: 12, margin: '6px 0 0' }}>
              Mindestens 8 Zeichen, mit Groß- und Kleinbuchstaben und mindestens
              einer Ziffer
            </p>
          </div>

          <div className="wc-field">
            <label htmlFor="confirmPassword">Passwort bestätigen</label>
            <input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              autoComplete="new-password"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="wc-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading || !token || !!passwordError}
            className="wc-btn wc-btn-primary wc-btn-block"
          >
            {loading ? 'Wird gespeichert…' : 'Passwort zurücksetzen'}
          </button>
        </form>
      )}

      <div className="wc-hr" style={{ margin: 0 }}></div>

      <div style={{ textAlign: 'center', fontSize: 14 }}>
        <Link to="/login">Zurück zum Login</Link>
      </div>
    </AuthShell>
  )
}
